export default {
  title: "Hujjatlar",
  missing: "Yetishmaydi: {{names}}",
  expiredLine: "Muddati tugagan: {{names}}",
  allSet: "Majburiy hujjatlar to'liq",
  noOpen: "Siz faqat holatni ko'rasiz. Faylni ochish uchun driverning sezgir ma'lumotlariga ruxsat kerak.",
  addOther: "Boshqa hujjat",
  otherName: "Hujjat nomi",
  chooseFile: "Fayl tanlash",
  changeFile: "Faylni almashtirish",
  accepted: "Foto (JPEG, PNG, HEIC) yoki PDF, 20 MB gacha",
  requiredTag: "Majburiy",
  currentTag: "Joriy",
  uploading: "Yuklanmoqda…",
  uploaded: "Hujjat yuklandi",
  requestedToast: "So'rov belgilandi",
  reminderFor: "Ertaga {{name}} uchun eslatma",
  archived: "Hujjat arxivlandi",
  failed: "Hujjat saqlanmadi",
  tooLarge: "Fayl juda katta (ko'pi bilan {{mb}} MB). Oddiy foto oling yoki PDF'ni siqing.",
  conflict: "Bu hujjatni hozirgina boshqa birov o'zgartirdi. Ro'yxat yangilandi — qayta urining.",
  versions: "Eski versiyalar ({{count}})",
  by: "{{name}}",
  expires: "{{date}} gacha amal qiladi",
  pages: "{{count}} sahifa",
  status: {
    missing: "Yuklanmagan",
    requested: "So'raldi {{when}}",
    received: "Yuklandi {{when}}",
    expiring: "muddati {{count}} kundan keyin tugaydi",
    expired: "muddati tugagan {{date}}",
  },
  statusName: { missing: "Yo'q", requested: "So'ralgan", received: "Bor", expiring: "Muddati tugayapti", expired: "Muddati tugagan" },
  actions: {
    upload: "Yuklash",
    newVersion: "Yangi versiya",
    request: "So'rash",
    requested: "So'ralgan",
    open: "Ochish",
    download: "Yuklab olish",
    editDates: "Sanalarni tahrirlash",
    archive: "Arxivlash",
    more: "Yana",
    reread: "AI bilan qayta o'qish",
    uploadAnother: "Yana bir nusxa yuklash",
  },
  archiveConfirm: {
    title: "{{label}} arxivlansinmi?",
    description: "Fayl eski versiyalarda qoladi; yangi fayl yuklanguncha bu tur \"yo'q\" deb ko'rinadi.",
  },
  dates: { title: "Hujjat sanalari", issued: "Berilgan sana", expires: "Amal qilish muddati", save: "Saqlash", cancel: "Bekor qilish", saved: "Sanalar saqlandi", state: "CDL shtati", statePlaceholder: "TX" },
  viewer: { status: "Holat", uploaded: "Yuklangan", requested: "So'ralgan", ocr: "AI o'qishi", archivedNote: "Eski versiya · {{date}} arxivlangan", state: "Shtat" },
  ocr: {
    pending: "O'qilmoqda…",
    done: "AI o'qidi",
    suggest: "AI taklifi",
    failed: "O'qilmadi",
    queued: "Qayta o'qilmoqda…",
    title: "Hujjatdan o'qilgani",
    modelLine: "{{model}} o'qidi. Siz qabul qilmaguncha hech narsa o'zgarmaydi.",
    dismiss: "Rad etish",
    close: "Yopish",
    accept: "Qabul qilish ({{count}})",
    applied: "Profilga yozildi",
    dismissed: "Taklif rad etildi",
    skipped: "O'tkazib yuborildi (sezgir ma'lumot ruxsati kerak): {{fields}}",
    nothing: "Bu hujjatdan maydon o'qilmadi.",
    kindMismatch: "Bu boshqa hujjatga o'xshaydi: {{kind}}.",
    nameMismatch: "Hujjatdagi ism profildagidan farq qiladi.",
    sensitive: "sezgir ma'lumot ruxsati kerak",
    lowConfidence: "tekshiring",
    same: "bir xil",
    cols: { field: "Maydon", profile: "Profilda", document: "Hujjatda" },
  },
  fields: {
    first_name: "Ism",
    last_name: "Familiya",
    date_of_birth: "Tug'ilgan sana",
    cdl_number: "CDL raqami",
    cdl_class: "CDL sinfi",
    cdl_state: "CDL shtati",
    cdl_expires: "CDL muddati",
    medical_card_expires: "Medical card muddati",
    endorsements: "Endorsement'lar",
  },
  kinds: {
    cdl: "CDL (old va orqa tomoni)",
    medical_card: "Medical card",
    application: "Ariza (application form)",
    mvr: "MVR",
    psp: "PSP hisoboti",
    other: "Boshqa hujjat",
  },
  preview: {
    zoomIn: "Kattalashtirish",
    zoomOut: "Kichraytirish",
    fit: "Oynaga sig'dirish",
    rotate: "Burish",
    prev: "Oldingi hujjat",
    next: "Keyingi hujjat",
    textLayer: "Rasmdagi matnni ko'rsatish",
    copyHint: "Nusxalash uchun rasmdagi yoki ro'yxatdagi qatorni bosing.",
    copied: "Nusxalandi",
    copyFailed: "Nusxalab bo'lmadi",
    noText: "Bu rasmdan matn hali o'qilmagan.",
    reading: "Matn o'qilmoqda…",
    readFields: "Hujjatdan o'qilgan",
    lines: "Rasmdagi matn",
    pdfHint: "PDF ichidagi matnni belgilab nusxalang.",
    of: "{{n}} / {{total}}",
    copyLine: "Nusxalash: {{text}}",
  },
  docFields: { full_name: "To'liq ism", issued_at: "Berilgan", expires_at: "Amal qiladi", restrictions: "Cheklovlar", examiner_name: "Shifokor", registry_number: "Reyestr raqami" },
  overview: { open: "Hujjatlarni ochish" },
};
